import { Transform, TransformFnParams } from 'class-transformer';

export const ToBoolean = () =>
  Transform(
    ({ value }: TransformFnParams) =>
      value === 'true' || value === true || value === 1 || value === '1',
  );
